import TYPES from './types';
import { put, post } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const updateAuthorization = params => dispatch => {
  const { id, table, ...rest } = params;

  dispatch({ type: TYPES.UPDATE_AUTHORIZATION.START, payload: params });

  return put(`/ocean-users/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_AUTHORIZATION.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_AUTHORIZATION.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      throw error;
    });
};

export const createAuthorization = params => dispatch => {
  const { table, ...rest } = params;

  dispatch({ type: TYPES.CREATE_AUTHORIZATION.START, payload: params });

  return post(`/ocean-users`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.CREATE_AUTHORIZATION.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_AUTHORIZATION.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      throw error;
    });
};

export const updateStatus = params => dispatch => {
  const { id, type, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_AUTHORIZATION.START });
  dispatch(updateTableRow({ data: params, table: 'authorization' }));

  return put(`/ocean-users/${id}`, rest)
    .then(response => {
      dispatch({
        type: TYPES.UPDATE_AUTHORIZATION.SUCCESS,
        payload: response.data
      });
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      dispatch(updateTableRow({ data: response.data, table: 'authorization' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_AUTHORIZATION.ERROR, payload: error });
      dispatch(resetTableRowUpdate({ data: params, table: 'authorization' }));

      throw error;
    });
};

export const updateStatusTable = params => dispatch => {
  const { id, type, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_AUTHORIZATION_STATUS.START });
  dispatch(updateTableRow({ data: params, table: 'authorization' }));

  return put(`/ocean-users/${id}`, rest)
    .then(response => {
      dispatch({
        type: TYPES.UPDATE_AUTHORIZATION_STATUS.SUCCESS,
        payload: response.data
      });
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      dispatch(updateTableRow({ data: response.data, table: 'authorization' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_AUTHORIZATION_STATUS.ERROR, payload: error });
      dispatch(resetTableRowUpdate({ data: params, table: 'authorization' }));

      throw error;
    });
};
